module.exports = __webpack_public_path__ + "media/images/locations/circle/austerlia-b86ed006de5733b9f6b1cbf950e2de0e.jpg";